<div style="background-color: #fafafa;margin: -20px;" class="d-flex justify-content-between mb-2 pl-3 pt-2"
  *ngIf="notDelProfile">
  <h3 class="mb-2 mt-0">{{ translationKeys.Authorization.Confirmation | translate }} </h3>
  <mat-icon (click)="onCloseDialog()" class="cursor mr-2">close</mat-icon>
</div>
<div class="d-flex justify-content-between mb-2 pl-3 pt-2" style="background-color: #fafafa;margin: -20px;"
  *ngIf="onlyDelete">
  <h3 class="mb-2 mt-3" style="font-weight: bold !important;">{{"GENERAL.REQUEST_TO_VERIFY_IDENTITY" | translate }}
  </h3>
  <mat-icon (click)="onCloseDialog()" class="cursor mr-2">close</mat-icon>
</div>
<div mat-dialog-content *ngIf="notDelProfile">
  <div style="line-height:26px;" class="p-2 mb-0 text-center">{{ translationKeys.Authorization.ConfirmationMessage | translate }}
  </div>
</div>
<div mat-dialog-content *ngIf='onlyDelete'>
  <div style="line-height:26px;" class="p-2 text-center">
    {{'AUTHORIZATION.CONFIRM_ONE_TIME_PASSWORD_MAIL' | translate }}
  </div>
</div>
<div mat-dialog-content *ngIf="onlyDelete">
  <div style="line-height:30px;" class="p-2 mb-0 text-center">{{email}}</div>
</div>
<div mat-dialog-actions class="d-flex mt-3 mb-2 justify-content-center" *ngIf="notDelProfile">

  <button (click)="onCloseDialog()" mat-raised-button type="submit" color="accent"
    class="card-header-action mr-3">{{ 'INSTITUTION_MANAGEMENT.NO' | translate }}</button>
  <button (click)="onClose($event)" mat-raised-button type="submit" color="primary"
    class="card-header-action mr-3">{{ 'INSTITUTION_MANAGEMENT.YES' | translate }}</button>

</div>
<div mat-dialog-actions class="d-flex mb-2 justify-content-center" *ngIf="onlyDelete">

  <!-- <button (click)="onCloseDialog($event)" mat-raised-button type="submit" color="accent" class="card-header-action mr-3" >No</button>  -->
  <button (click)="onConfirmDelete()" mat-raised-button type="submit" color="primary"
    class="card-header-action mr-3">{{ translationKeys.SOPObservation.Continue | translate }}</button>
</div>


<div *ngIf="profileModify">
  <div class="d-flex justify-content-between mb-2">
    <h3 class="mb-2 mt-0 font-weight-bold">{{ translationKeys.ProfileDetails.ValidateUser | translate }} </h3>
    <mat-icon (click)="onCloseDialog()" class="cursor">close</mat-icon>
  </div>
  <div >
    <div style="line-height:30px;" class="text-left">
      {{ translationKeys.ProfileDetails.ValidateUserMessage | translate }}
    </div>
  </div>
  <div class="col-8 p-0 mt-4">
    <div class="form-group">
      <mat-form-field class="example-full-width">
        <input matInput 
          inputSanitizer type="password" 
          #passwordModel="ngModel" 
          maxlength="30"
          name="currentPassword" id="currentPassword" required
          placeholder="{{ translationKeys.Authorization.Password | translate }} (Max 30)"
          [(ngModel)]="authPassword"
          [ngClass]="{ 'is-invalid':  submitted && passwordModel.invalid }"
          [type]="hide ? 'password' : 'text'"
          aria-describedby="emailHelp"
          autofocus>
      </mat-form-field>
      <button class="password-buthide" mat-icon-button matSuffix (click)="hide = !hide"
        [attr.aria-label]="'Hide password'" [attr.aria-pressed]="hide">
        <mat-icon>{{hide ? 'visibility_off' : 'visibility'}}</mat-icon>
      </button>
      <div *ngIf="submitted && passwordModel.errors" class="invalid-feedback">
        <div *ngIf="passwordModel.errors.required">
          {{ translationKeys.ErrorMessages.RequiredPassword | translate }}
        </div>
      </div>
    </div>
  </div>
 
  <div class="col-12 p-0 d-flex mb-2 justify-content-end">
    <button (click)="onModify()" type="submit" 
      class="btn-bd card-header-action">{{ 'INSTITUTION_MANAGEMENT.YES' | translate }}</button>
  </div>
</div>

<div *ngIf="consentConfirm">
  <div style="background-color: #fafafa;margin: -20px;" class="d-flex justify-content-between mb-2 pl-3 pt-2">
    <h3 class="mb-2 mt-0 font-weight-bold">{{ translationKeys.InstitutionManagement.Confirmation | translate }}</h3>
    <mat-icon (click)="onCloseDialogConsern()" class="cursor mr-2">close</mat-icon>
  </div>
  <div mat-dialog-content>
    <div style="line-height:30px;" class="p-2 text-center">
      {{ 'INSTITUTION_MANAGEMENT.DISAGREE_CONSENT_ASK' | translate }}
    </div>
  </div>
  <div>
  </div>

  <div mat-dialog-actions class="d-flex mb-2 justify-content-center">
    <button (click)="onConsernUpdate()" mat-raised-button type="submit" color="primary"
      class="card-header-action mr-3">{{ 'INSTITUTION_MANAGEMENT.YES' | translate }}</button>
  </div>
</div>
